export const staticStrings = {
  bulkRefundReport: 'Bulk Refund reports',
  bulkRefundSummary: 'Bulk Refund Summary',
  buttonSummary: 'Summary',
  buttonReports: 'Reports',
  buttonUpload: 'Upload',
  btnSampleDownload: 'Sample Download',
  bulkRefundSelectFile: 'Select File',
  bulkRefundLabel: 'Bulk Refund',
  active: 'Active',
  hotMerchant: 'Hot Merchant',
  activeStatus: 'Active',
  hotMerchantStatus: 'HotMerchant',
  merchantAggreement: 'Merchant Agreement',
  tnc: 'Terms of Use',
  privacyPolicy: 'Privacy Policy',
  grevienceRedressal: 'Grevience Redressal',
  policyDocuments: 'Policy Documents',
  kycAML: 'Onboarding & KYC Policy',
  billpayTnC: 'Billpay Terms & Conditions',
  labelCopyright: '© 2021 Copyright JioPay',
  targetBlank: '_blank',
  myAccount: 'My Profile',
  logout: 'Logout',
  accountCreation: 'Your account creation request is submitted succesfully',
  notifyMessage: 'It will take us 2-3 days to verify your account.We will notify you when it is ready',
  trackingMessage: 'Please mention this ID when you contact us for the status of your account',
  emailUs: ' Email us',
  support: 'Support@jio.com',
  jioHelpLineNumber: ' +91-8978675645',
  callUs: 'Call us',
  trackingId: 'TRACKING ID',
  lookingFor: ' What are you looking for?',
  login: 'Login',
  alreadyHaveAccount: 'Already have an account?',
  businessNeeds: 'Everything your business needs',
  businessPara:
    'Jio Pay has the ideal solution for your business needs. Our innovation at scale, experience and immense understanding of the Indian market can do wonders for your business. Be it marketplace payments, subscription payments or on-demand payments on the go, we help deliver the best experience for your users.',
  enablesPayment: 'Explore how JioPay can solve your payment needs',
  developerCen: 'Developer centric product',
  developerCenPara:
    'Integrating with Jio Pay lets you offer your users multiple ways to pay – and we’re adding more frequently. Build and test with Jio Pay on sandbox. When you’re done, start collecting user payments instantly',
  exploreDocs: 'Explore the developer docs',
  acceptPayment: `The best way
to accept 
online payments`,
  acceptPaymentsPara:
    'JioPay is the most effective and efficient platform to accept payments in India. With state of the infra, class leading risk and fraud engines and a plethora of options, accepting payments has never been this simple!',
  signup: 'Sign Up',
  talkto: 'Talk To Us',
  growBusiness: 'Grow your business with JioPay',
  products: 'Products',
  devs: 'Developers',
  pricing: 'Pricing',
  contact: 'Contact Us',
  signin: 'Sign In',
  merchantPartner: 'Our merchant partners',
  partnerSay: 'Our partners say',
  partnerSayText:
    'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
  partnerName: 'Sumeet',
  partnerDesig: 'VP, Hamsley, India',
  payDirect: 'JioPay Direct',
  payDirectText: 'Get paid by your users anytime and anywhere',
  paySubscribe: 'JioPay Repeat',
  paySubscribeText: 'Bill users automatically on a recurring basis',
  payInvoice: 'JioPay Collect',
  payInvoiceText: 'Create digital payment links after fulfilment',
  payMarket: 'JioPay Onward',
  payMarketText: 'Accept user payments and settle them multi-sided between sellers',
  payBills: 'JioPay BillMe',
  payBillsText: 'Collect payment for communities & more',
  whyjio: 'Why JioPay?',
  incCon: 'Increase Conversion',
  betterSales: 'Better your sales and retention with our carefully crafted checkout experience',
  widePresence: 'Widen presence',
  acrossActive: 'Widen presence',
  mitigateRisk: 'Mitigate risk & secure data',
  reach3Million: 'Reach 375+ Million active Jio users across the country',
  preventFraud: 'Prevent fraudulent transactions while processing genuine orders',
  omniChannel: 'Simplified Omni channel experience',
  uniqueExp: 'Create unique experiences that are specific to your product across form factors',
  ourProducts: 'Our Products',
  cancel: 'Cancel',
  apply: 'Apply',
  fieldSettings: 'Field Settings',
  recents: 'Recent',
  recentTransaction: "Today's Transactions",
  highlights: 'Transactions Overview',
  dateRange: 'Date Range',
  analytics: 'Analytics',
  performance: 'Performance by volume',
  to: 'to',
  titleAlert: 'Alert',
  loadingMessage: 'Please wait, your request is being processed',
  refundTransactions: 'Refund Transactions',
  done: 'Done',
  labelDownload: 'Download',
  labelGenerate: 'Generate Now',
  settlementNote:
    'Note : Service fee, service tax, refunds and charge backs will be deducted before settlement wherever applicable',
  fieldSettingsSubHeader: 'Choose the data fields to be shown in the Transaction table',
  resetFields: 'Reset to default Settings',
  gotoDashboard: 'Dashboard',
  summary: 'Summary',
  showTransaction: 'No new payments',
  noRefunds: 'No refunds',
  noDataQrCode: 'Your QR will show up here. You will be able to accept payments through the QR.',
  showSettlementEmpty: 'No settlements',
  noDataRecent: 'Your recent transactions will show up here.',
  noBillPayments: 'Your bill payment transactions will show up here.',
  noDataTransDesc: 'Start accepting payments from customers',
  noRefundDesc: 'Your refunded payments will show up here',
  noDataSettlementDesc: 'Start accepting payments from customers',
  addBankAcc: 'Please add your bank account.',
  addBankButton: 'Add Bank Account',
  selectbank: 'Add settlement account',
  fetchingLinkedBank: 'Fetching your bank accounts linked to mobile number',
  fetchBanks: 'fetching Banks',
  selectBankAc: 'Select Bank Account',
  allPay: 'All the payments will be settled to the selected account',
  findIfs: 'Find ifsc code',
  weCoudntFind: 'We couldn’t find any bank account linked',
  youCanAddAc: 'You can add your bank details below.',
  AboutUsDesc:
    'JioPay Business App is especially designed for retailers, businessmen or any other service providers to accept payments from JioPay customers securely and easily.\n\nWith JioPay Business app, you can perform your day-to-day activities like accepting payments, viewing past transactions, doing refunds to your customers, changes in your profile and much more.',
  NoSearch: 'Oops!..No results found',
  transDetails: 'Transaction Details',
  screenLockTitle: 'Secure your account',
  enableLockBtnLabel: 'Enable screen lock',
  labelEnableLater: 'I’ll do it later',
  screenLockHelperText:
    'Use your existing phone lock to add additional layer of security to your JioPay Business account.',
  enableScreenLock: 'Enable screenlock to protect your account',
  signUpPhone: 'Phone Number (10 Digits)',
  paymentLinks: 'Payment Links',
  createPaymentLink: '+ Create Payment Link',
  maxTxnLimit: '₹ 50,000',
  downloadSampleFile: 'Download Sample File',
  qrPath: '/storage/emulated/0/Download/JioPayUPI',
  reportPath: '/storage/emulated/0/Download',
  insights: 'Business Insights',
  settlements: 'settlements',
  settlement: 'settlement',
  settingsOtpTitle:
    '2nd factor validation required to view the Key value, we have send you a 6-Digit OTP on your registered mobile number ',
  userManagement: 'User Management',
  addNewUserData: 'Enter New User Details',
  editUserData: 'Edit User Details',
  addNewuser: 'Add New User',
  editPrevUser: 'Edit User',
  nameOfUser: 'Name Of The User',
  mobNum: 'Mobile Number',
  role: 'Department',
  access_rights: 'Access Rights',
  dashboard: 'Dashboard',
  transactions: 'Transactions',
  transactionsDetails: 'Transaction Details',
  Webhooks: 'Webhooks',
  notAuthorized: "You're not authorized to access this!",
  apiCredentials: 'API Credentials',
  copyText: 'MID copied to clipboard',
  SelectAll: 'Select All',
  bulkBeneficiaryLabel: 'Bulk Beneficiaries',
  addBeneficiary: 'Add Beneficiary',
  noOperators: 'No operators',
}

export const headerTitle: any = {
  0: 'Transactions',
  1: 'Settlements',
  2: 'Refunds',
}

export const footerStrings = {
  whyjio: 'Why JioPay?',
  incCon: 'Increase conversions',
  wide: 'Widen presence',
  risk: 'Mitigate risk',
  experience: 'Simplified experience',
  products: ' Products',
  direct: 'JioPay Direct',
  subscribe: 'JioPay Subscribe',
  invoice: 'JioPay Invoice',
  market: 'JioPay Marketplace',
  bill: 'JioPay BillMe',
  devs: 'Developers',
  docs: 'Developer Documentation',
  apiRef: 'API Reference',
  more: 'More',
  about: 'About',
  terms: 'Privacy Terms',
  conditions: 'Terms of use',
}

export const loginStrings = {
  pay: 'Pay',
  loginMsg: 'The best way to accept online payments',
  dontHaveAcc: "Don't have an account?",
  signUp: 'Sign Up',
  privacyPolicy: 'Privacy Policy',
  contactUs: staticStrings.contact,
  termsNConditions: 'Terms & conditions',
  forgotPwd: 'Set/Reset Password',
  rememberMe: 'Remember me',
  loginJiopay: 'JioPay Login',
  login: 'Login',
  userMobileNumber: 'userMobileNumber',
  alreadyHaveAccnt: 'Already have an Account?',
  signIn: 'Sign In',
  createAccount: 'Create Account',
  alradyhaveAc: 'already have an account?',
  isRemembered: 'isRemembered',
}

export const otpStrings = {
  enterOtp: 'Enter OTP',
  weHaveSent6DigitOtp: 'We have sent you a 6-digit OTP on',
  editWithBraces: ' (Change)',
  plsTryAfterSomeTimeForOtp: 'Please try logging in after some time if you are having trouble \nreceiving the OTP.',
  verifyOtp: 'Verify OTP',
  resendOtp: 'Resend OTP',
}

export const forgotPwdStrings = {
  sendOtp: 'Send OTP',
  forgotPassword: 'Set/Reset Password',
  forgotPwdAlertTitle: 'Success',
  forgotPwdAlertMsg: 'Create password link has been sent to your email.',
  resetPassword: 'Reset your password',
  pwdMustHaveAtleast: 'Password must have at least :',
  setNewPassword: 'Set a New Password',
  eightCharacters: '8 Characters',
  oneLowerCaseLetter: '1 lower case letter',
  oneCapitalLetter: '1 CAPITAL letter',
  oneSpecialCharacter: '1 special character',
  oneDigit: '1 digit',
  noSequentialDigit: 'No sequential digit allowed!',
  noSequentialAlbhabet: 'No repeating albhabets allowed!',
  noRepeatingDigit: 'No more than 3 repeating digits / alphabets allowed!',
  noSpace: 'No blank space allowed',
  confirmPassword: 'Confirm Password',
  setPwdAndLogin: 'Set password & login',
  fieldNamePassword: 'password',
  fieldNameConfPwd: 'passwordConfirm',
  weWillSendOtpToNum: 'We will send the 6-digit OTP to below number',
  capitalLettersRegex: /[A-Z]/,
  oneDigitRegex: /\d/,
  repeatingDigitRegex: /(.)\1{3,}/,
  oneSpecialCharRegex: /[!@#$%^&*]/,
  enteredMobile: 'enteredMobile',
  setUrPassword: 'Set your password',
  setPwdAndSignUp: 'Set password & sign up',
  proceed: 'Proceed',
}

export const userMgmtStrings = {
  edit: 'Edit',
  noUsersAvailable: 'No Users Available',
  loading: 'Loading...',
  delete: 'Delete',
  deleteConf: 'Are you sure want to delete ?',
  cancel: 'Cancel',
  usersList: 'Users List',
  addUser: 'Add User',
  bulkActivation: 'Bulk Activation',
  instructionsForSuMerc: 'Instructions for Super Merchant',
  bulkActInfo1:
    'For generating activation codes for a particular MID, please select MID for which you want to generate Activation Codes And Click on "Generate And Download Activation Codes" button.',
  bulkActInfo2:
    'Please note that by Generating the Activation Codes for a particular MID or all MIDs, transactions will start failing on your Billing POS Application (if already set up/running with old Activation Codes). Use this capability with caution.',
  bulkActInfo3:
    'The downloaded file will have Activation Codes against each MID/TID along with Store Details corresponding to the MID/TIDs.',
  bulkActInfo4:
    'Once these details are configured, you can start accepting JioMoney and/or Credit/Debit Cards (If opted for Credit/Debit Card transactions) from the Billing POS application.',
  bulkActInfo5:
    'You can also generate Activation for a specific TID (terminal/user) by using capability provided in "Users" tab above. Token and Activation Code are the same.',
  bulkActInfo6:
    'As token when configured for the first time gets you activated for accepting JioMoney as a payment method, we call it Activation Code.',
  bulkActGenFor: 'Bulk Activation Code to be generated for : ',
  genActCode: 'Generate Activation Code',
  userInfo: '*Fill the required data and select permissions to allow the portal user to access the portal',
  user: 'User',
}

export const profileStrings = {
  retry: 'Retry',
  changeMobileNumber: 'Change Mobile Number',
  change: 'Change',
  changePassword: 'Change Password',
  enterOtp: 'Enter OTP',
  otp: 'OTP',
  verify: 'Verify',
  residentialAddress: 'Residential Address',
  businessAddress: 'Business Address',
  addressLine1: 'Address Line 1',
  addressLine2: 'Address Line 2',
  pincode: 'Pincode',
  state: 'State',
  country: 'Country',
  city: 'City',
  na: 'NA',
  edit: 'Edit',
  address: 'Address',
  cancel: userMgmtStrings.cancel,
  save: 'Save',
  editBuzDetails: 'Edit Business Details',
  upoadSupDoc: 'Upload Supporting Document',
  selectProofOfAdd: 'Select Proof Of Address',
  addFile: 'ADD FILE',
  uploadFile: 'Upload File',
  business: 'Business',
  businessName: 'Business Name',
  mid: 'MID',
  sodexoAcceptance: 'Sodexo Acceptance',
  supPayAcceptance: 'Supplier Payment Acceptance',
  hypLocPayAcceptance: 'Hyperlocal Payment Acceptance',
  businessVPA: 'UPI Handle',
  yes: 'Yes',
  no: 'No',
  editGstDetails: 'Edit GST Details',
  gstDetails: 'GST Details',
  gstIn: 'GSTIN',
  gstMercCategory: 'GST Merchant Category',
  gstDealerCategory: 'GST Dealer Category',
  typeOfBuzz: 'Type Of Business',
  changeEmailNWeb: 'Change Email and Website',
  paymentAcceptance: 'Payment Acceptance',
  posCCDC: 'POS Credit Card/Debit Card',
  onlineCCDCNB: 'Online CC/DC/Net Banking',
  upi: 'UPI',
  personalDetails: 'Personal Details',
  mobileNumber: 'Mobile Number',
  emailId: 'Email Id',
  selectIfsc: 'Select IFSC',
  chooseIfsc: 'Choose IFSC',
  selectBank: 'Select Bank',
  selectCity: 'Select City',
  selectBranch: 'Select Branch',
  notificationDetails: 'Notification Details',
  notificationMobileNum: 'Notification Mobile Number:',
  notificationEmailId: 'Notification Email Id:',
  notificationSetting: 'Notification Settings',
  sms: 'SMS',
  email: 'Email',
  push: 'PUSH',
  successTxns: 'Success Transactions Alert',
  stlmentSummary: 'Settlement summary',
  submit: 'Submit',
  changeEmailId: 'Change Email Id',
  clickAccToEdit: 'Click an account to edit',
  getIfscCode: 'Get IFSC Code',
  upSetlInfo: 'Update Settlement Information',
  paymentSettlementInfo: 'Payment Settlement Info',
  sodexo: 'Sodexo',
  supplier: 'Supplier',
  hyperLocal: 'HyperLocal',
  personal: 'Personal',
  finance: 'Finance',
  notification: 'Notification',
  failTxnAlert: 'Fail Transaction Alert',
  chargeBackAlert: 'Chargebacks Alert',
  downTimeNotAlert: 'Downtime Notification Alert',
  lowBalAlert: 'Low Balance Alert',
  txnRepGen: 'Transaction Report Generation',
  refRepGen: 'Refund Report Generation',
  bulkRefRepGen: 'Bulk Refund Report Generation',
  setlmtRepGen: 'Settlement Report Generation',
  profChange: 'Profile Change',
  supTickUpdates: 'Support Ticket Updates',
  userAcUpdates: 'User Account Updates',
  portal: 'Portal',
}

export const supportStrings = {
  title: 'Support',
  submit: 'Submit',
  emailUs: 'Email us for any query at',
  emailId: 'merchant.support@jiopay.in',
  contactUs: 'Contact Us',
  supportNumber: '8356903964',
  contactSupport: 'You can also contact us on',
}

export const blockUnblockStrings = {
  title: 'Block / UnBlock Account',
  block: 'Block',
  unBlock: 'UnBlock',
  suspend: 'Suspend',
  resume: 'Resume',
  changeStatus: 'Change Status',
}
export const kycStrings = {
  kycTitle: 'KYC Documentation Details',
  editKycTitle: 'Edit KYC Documentation Details',
  labelCancel: 'Cancel',
  labelChange: 'Change',
  labelPOI: 'Proof of Identity(POI)*',
  notAvailable: 'NA',
  labelPOA: 'Proof of Address (POA)',
  labelPhoto: 'Photo*',
  labelFinStatement: 'Financial Statement',
  labelPoB: 'Proof of Business (POB)',
  otherBusinessDetails: 'Other Business Details',
  labelYearsOfBusiness: 'Years of Business*',
  authSignatory: 'Authorised signatory',
}

export const upgradeStrings = {
  labelWallet: 'JioMoney Wallet (Rs.) :',
  cardsLabel: 'Debit/Credit Card (Rs.) :',
  currentLimitTitle: 'Current Transaction Limit',
  upgradeTitle: 'Upgrade Limit',
  submitFinDoc: '(Submit financial document*)',
  selectFinDoc: 'Select Financial Document',
  leaveReply: 'Leave a Reply',
  btnLabelSave: 'Save',
}

export const actionMenuStrings = {
  today: 'Today',
  yesterday: 'Yesterday',
  customDate: 'Custom Range',
  infiniteScrollRange: 'Infinite Scroll',
  excel: 'Excel',
  string: 'string',
  lastSeven: 'Last 7 Days',
  lastFifteen: 'Last 15 Days',
  lastThirty: 'Last 30 Days',
  lastNinty: 'Last 90 Days',
  labelGenerate: 'Generate Report',
  export: 'Export',
  refundCancel: 'refund-cancel',
  labelRefundCancel: 'Refund/Cancel Transaction',
  sortBy: 'Sortby',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
}

export const fieldSettingsFilterStrings = {
  id: '0',
  additionalDataNational: 'additionalDataNational',
  retrievalReferenceNumber: 'retrievalReferenceNumber',
  issRefData: 'issRefData',
  cardType: 'cardType',
  paymentType: 'paymentType',
  transactionDateTime: 'transactionDateTime',
  transactionAmount: 'transactionAmount',
  transactionDisposition: 'transactionDisposition',
  action: 'action',
  startDateTime: 'startDateTime',
  accountOne: 'accountOne',
  accountNumber: 'accountNumber',
  tokenPan: 'tokenPan',
  refundAmount: 'refundAmount',
  acquirerBusiness: 'acquirerBusiness',
  acquirerInstitution: 'acquirerInstitution',
  acquirerTerminal: 'acquirerTerminal',
  actionCode: 'actionCode',
  authCode: 'authCode',
  clerk: 'clerk',
  extendedData: 'extendedData',
  financialType: 'financialType',
  issuerInstitution: 'issuerInstitution',
  merchantCity: 'merchantCity',
  merchantName: 'merchantName',
  merchantType: 'merchantType',
  surCharge: 'surCharge',
  systemTraceAuditNumber: 'systemTraceAuditNumber',
  transactionClass: 'transactionClass',
  transactionType: 'transactionType',
  accountNoSufix: 'accountNoSufix',
  accountNoPrefix: 'accountNoPrefix',
  forwardingId: 'forwardingId',
  acqDate: 'acqDate',
  acqCountryCode: 'acqCountryCode',
  acqDateConver: 'acqDateConver',
  acqMsgResonCode: 'acqMsgResonCode',
  addDataAcq: 'addDataAcq',
  addDataIssuer: 'addDataIssuer',
  availableBal: 'availableBal',
  issCountryCode: 'issCountryCode',
  issDateConv: 'issDateConv',
  cardLogoId: 'cardLogoId',
  cardAcceptTer: 'cardAcceptTer',
  cardAcceptId: 'cardAcceptId',
  conFee: 'conFee',
  funcCode: 'funcCode',
  emiInd: 'emiInd',
  labelFieldSettings: 'Field Settings',
  labelFilters: 'Filters',
}

export const transactionScreenStrings = {
  starTime: '00:00:00',
  endTime: '23:59:59',
  noRecords: 'No Records Available',
  empty: '',
  refund: 'Refund',
  cancel: 'Cancel',
  action: 'ACTION',
  loading: 'Loading...',
  storyLabel: 'Screens',
  starTimeOnly: '000000',
  endTimeOnly: '235959',
}

export const refundScreenStrings = {
  starTime: '00:00:00',
  endTime: '23:59:59',
  noRecords: 'No Records Available',
  empty: '',
  refund: 'Refund',
  cancel: 'Cancel',
  action: 'ACTION',
  loading: 'Loading...',
  storyLabel: 'Screens',
  starTimeOnly: '000000',
  endTimeOnly: '235959',
}

export const settlementScreenString = {
  starTime: '00:00:00',
  endTime: '23:59:59',
  noRecords: 'No Records Available',
  empty: '',
  refund: 'Refund',
  cancel: 'Cancel',
  action: 'ACTION',
  loading: 'Loading...',
  storyLabel: 'Screens',
  starTimeOnly: '000000',
  endTimeOnly: '235959',
}

export const sortBy = {
  sortByDesc: 'DESC', //Changed to DESC as by default txns list should be in Decending order
  sortField: 'transactionDateTime',
}

export const hoverViewStrings = {
  labelFileName: 'Settlement File Name:',
  labelNeftRtgsNo: 'NEFT/ RTGS No.:',
  na: 'NA',
  labelERN: 'ERN : ',
  labelTotalRefunded: 'Total Refunded:',
  labelPendingamount: 'Pending amount:',
  labelSettlementDate: 'Settlement Date:',
}

export const customerDetailsStrings = {
  labelCustomerDetails: 'Customer Details',
  labelCustomerId: 'Customer Id',
  labelCustomerName: 'Customer Name',
  labelAddressLine1: 'Address Line1',
  labelCity: 'City',
  labelZipCode: 'Zip Code',
  labelMobileNumber: 'Mobile Number',
  labelEmail: 'Email',
  labelAddressLine2: 'Address Line2',
  labelState: 'State',
}

export const transactionDetailsStrings = {
  labelTransactionDetails: 'Transaction Details',
  headerErn: 'Merchant Ref No : ',
  labelTimestamp: 'Timestamp',
  labelERN: 'Merchant Ref No : ',
  labelFailureReason: 'Failure Reason',
  labelChannel: 'Channel',
  labelAmount: 'Amount',
  labelRRN: 'JioPay Id',
  labelStatus: 'Status',
  labelCurrency: 'Currency',
  labelHeader: 'Merchant Ref No : ',
  export: 'Export',
  empty: '',
  na: 'NA',
  refund: 'Refund',
  inr: 'INR',
  terminalId: 'Terminal Id',
}

export const paymentDetailsStrings = {
  labelPaymentDetails: 'Payment Details',
  labelPaymentMode: 'Payment Mode',
  labelCardNumber: 'Card Number',
  labelBankRefNo: 'Bank Ref No.',
  labelPaymentType: 'Payment Type',
  labelCustomerName: 'Customer Name',
  labelRefundDetails: 'Refund Details',
  labelSettlementDetails: 'Settlement Details',
  labelSettlementDate: 'Settlement Date',
  labelUTRNumber: 'UTR Number',
  labelSettlementFilename: 'Settlement Filename',
  labelSettlementRefNumber: 'Settlement Ref Number',
  labelSettlementStatus: 'Settlement Status',
  labelConvenienceFee: 'Convenience Fee',
  labelConvenienceAmount: 'Convenience Fee',
  labelUGST: 'UGST',
  labelIGST: 'IGST',
  labelSGST: 'SGST',
  labelCGST: 'CGST',
  labelOriginalTxnAmount: 'Original Txn Amt',
  offerId: 'Offer Id',
  udf1: 'UDF 1',
  udf2: 'UDF 2',
  udf3: 'UDF 3',
  udf4: 'UDF 4',
  udf5: 'UDF 5',
  settlementRefNumber: 'Settlement RefNumber',
  accountNumber: 'Account Number',
}

export const listStrings = {
  selected: 'SELECTED',
  original: 'ORIGINAL',
  testMode: 'Test Mode',
}

export const filtersStrings = {
  labelFilters: 'Filters',
  labelCancel: 'Cancel',
  labelApply: 'Apply',
  labelAmountRange: 'Amount Range',
  labelMax: 'Max',
  labelMin: 'Min',
  testIdMin: 'TestMin',
  testIdMax: 'TestMax',
  empty: '',
  selectedFilters: 'selectedFilters',
  subTitle: 'Filter the data to be shown in the table',
  otherFilters: 'Other Filters',
  contact: 'Customer Contact',
  email: 'Customer Email',
  paymentLinkId: 'Jio Link Id',
  restoreDefault: 'Reset to default Settings',
  merchantLinkId: 'Merchant Link ID',
  amount: 'Amount',
  invoiceNumber: 'Invoice Number',
  testIdContact: 'TestContact',
  testIdEmail: 'TestEmail',
  testIdJioLinkId: 'TestJioLinkId',
  testIdMerchantLinkId: 'TestMerchantLinkId',
  testIdAmount: 'TestAmount',
  testIdInvoiceNumber: 'TestInvoiceNumber',
  clearAll: 'Clear filters',
  beneficiaryType: 'Beneficiary Type',
  beneficiaryEmail: 'Beneficiary Email',
  beneficiaryName: 'Beneficiary Name',
  beneficiaryPhoneNumber: 'Beneficiary Phone Number',
  beneficiaryId: 'Beneficiary Id',
  beneficiaryAccountNumber: 'Beneficiary Account No',
  beneficiaryIfsc: 'Beneficiary IFSC',
  beneficiaryUpiVpa: 'Beneficiary UPI VPA',
  beneficiaryCardNumber: 'Beneficiary Card No',
}

export const tableItemStrings = {
  action: 'action',
  refunded: 'refunded',
  canceled: 'canceled',
  checkbox: 'checkbox',
  changeStatus: 'changeStatus',
  resume: 'Resume',
  suspend: 'Suspend',
  success: 'SUCCESS',
  csv: 'CSV',
  pdf: 'PDF',
  deleteCaps: 'DELETE',
  invalidAmount: 'Invalid amount',
  unBlock: 'UnBlock',
  id: 'id',
  links: 'links',
  extendedData: 'extendedData',
  DELETE: 'DELETE',
  startTime: '00:00:00',
  endTime: '23:59:59',
  transactionAsc: 'transactionDateTime,asc',
  defaultSortKey: 'date',
  decreasingSortOrder: 'desc',
  increasingSortOrder: 'asc',
  noSortOrder: 'noSort',
  download: 'Download',
  loading: 'loading',
  transactionDesc: 'transactionDateTime,DESC',
  link: ['jioLinkId', 'subscriptionId', 'cId', 'invoice'],
}

export const dashboardStrings = {
  toBeSettled: 'To be settled: ',
  settled: 'Settled: ',
  emptyMessage: 'No transactions Available',
  loading: 'Loading...',
}

export const errorCodes = {
  otpTryAfterSometime: '401',
}

export const onBoardStrings = {
  merchantAccount:
    'Merchant Account signup completed, you’re in Test Mode, try out various features of your dashboard, to start collecting payments & to unlock all other features, please complete your account activation form and complete your KYC.',
  info: 'Please keep the below mentioned documents handy to complete the process:',
  infoList: 'Business & Authorised Signatory PAN Number.,GSTN/CIN/LLPIN Numbers.,Bank account and IFSC numbers.',
  infoList2: 'Authorised signatory ID & Address proof.,Business PAN & registration documents.,Cancelled Cheque leaf',
  submittedInfo:
    'Account activation process completed successfully, your KYC document is Under Review, we will reach out to you if any further clarification needed. The review process usually takes 24 to 48 Hours to complete. Meanwhile you can start accepting payments from your customers.',
  doLater: 'Do later in your own time',
  kycHeader: 'KYC Update Request Submitted',
  kycTitle:
    'Your KYC is Under Review, we will reach out on your contact email or phone for further clarification if needed. The review process usually takes 24 to 48 hours to complete. Meanwhile you can start accepting payments from your customers.',
  accountHeader: 'Account Activated',
  accountSubtitle: 'Ready to accept payments',
  accountTitle:
    'Your merchant account got activated, you can now start accepting payments from your customers. Payments settlements will be activated after completing your KYC.',
  updateKyc: 'Update Kyc',
  activateAccount: 'Activate Account',
  acceptPayments: 'Start accepting Payments',
  gotoDashboard: 'Go to dashboard',
  completeKyc: 'Complete KYC',
}

export const customError = {
  errorOccured: 'Error while processing request!',
}

export const BENEFICIARY_ENTITY_TYPE = '1'
export const PLATFORM_FEE_ENTITY_TYPE = '2'
